'use client';

import { useEffect, useState } from 'react';
import style from './BottomNav.module.scss';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Avatar from '../ui/avatar/Avatar';
import { useAppSelector } from '@/store/hook';
import { DEFAULT_AVATAR } from '@/constants/image';

const BottomNav = () => {
  const pathName = usePathname();
  const meInfo = useAppSelector((state) => state.auth.meInfo);

  // 避免 SSR / CSR 初次 render 不一致：先用預設頭像，等 mount 後再換成 meInfo 的頭像
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const avatarSrc = mounted && meInfo?.u_photo ? meInfo.u_photo : DEFAULT_AVATAR;

  return (
    <nav className={`d-lg-none  ${style.navMobile}`}>
      <ul className="d-flex justify-content-around">
        <li>
          <Link
            href="/"
            className={`d-flex flex-column align-items-center NavLinkIcon ${
              pathName === '/' ? 'active text-brand' : 'text-dark'
            }`}
          >
            <span className="icon iconHome" />
            <span>探索AR</span>
          </Link>
        </li>
        <li>
          <Link href="/me/profile" className="d-flex flex-column align-items-center">
            <span
              className={style.avatar}
              style={{
                outline: pathName === '/me/profile' ? '2px solid #da5271' : '',
              }}
            >
              <Avatar src={avatarSrc} size={24} />
            </span>
          </Link>
        </li>
        <li>
          <Link
            href="/me/wallet"
            className={`d-flex flex-column align-items-center NavLinkIcon ${
              pathName === '/me/wallet' ? 'active text-brand' : 'text-dark'
            }`}
          >
            <span className="icon iconWallet" />
            <span>籌碼包</span>
          </Link>
        </li>
        {/* <li>
          <Link
            href="/me/profile-green-coin"
            className={`d-flex flex-column align-items-center NavLinkIcon ${pathName === '/me/profile-green-coin' ? 'active text-brand' : 'text-dark'}`}
          >
            <span className="icon iconWe" /> <span>我們倆</span>
          </Link>
        </li>
        <li>
          <Link
            href="/me/profile-red-coin"
            className={`d-flex flex-column align-items-center NavLinkIcon ${pathName === '/me/profile-red-coin' ? 'active text-brand' : 'text-dark'}`}
          >
            <span className="icon iconIncome" /> <span>玩斜槓</span>
          </Link>
        </li> */}
      </ul>
    </nav>
  );
};

export default BottomNav;
